/* eslint-disable camelcase */

import { mapActions, mapGetters } from "vuex";

import Compressor from "compressorjs";
import Vue from "vue";
import _ from "lodash";
import bankCode from "../constants/bank-code";
import datePickLocale from "../constants/date-pick-locale";
import formDatas from "@/lib/formDatas";
import reactNativeWebViewHelper from "@/lib/reactNativeWebViewHelper";
import sendCompanyCode from "../constants/send-company-code";

const mixin = {
  created() {
    this.document = document;
    this.window = window;
    this._ = _;
    this.webUrl = process.env.VUE_APP_WEB_URL;
    this.apiUrl = process.env.VUE_APP_API_URL;
    this.storageUrl = process.env.VUE_APP_STORAGE_URL;
    this.scheme = process.env.VUE_APP_SCHEME_NAME;
    this.shareKEY = process.env.VUE_APP_SHARE_KEY;
    this.onerrorSrc =
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKfdLFp3Byzzs4rXrkc3agvVwY9JoZKpDJrw&usqp=CAU";

    this.isDev =
      process.env.NODE_ENV === "development" &&
      window.location.hostname === "localhost";

    this.$constants = {
      datePickLocale,
      bankCode,
      sendCompanyCode,
    };
  },
  computed: {
    ...mapGetters([
      "isUser",
      "user",
      "keepAlive",
      "isClient",
      "isDealer",
      "isSocial",
      "hasNeededInfo",
      "isVerified",
      "local",
      "report",
      "selected_el_no",
      "inquiryPopup",
      "alertPopup",
      "privacyPopup",
      "serviceModalPopup",
      "confirmPopup",
      "clientEstimate",
    ]),
  },
  methods: {
    ...mapActions([
      "userLogin",
      "userDetail",
      "userDetailUpdate",
      "userLogout",
      /* 'settingsLoad', */
      "keep",
      "unkeep",
      "clearKeep",
      "toggleInquiry",
      "toggleAlert",
      "toggleAlertWarning",
      "toggleConfirm",
      "togglePrivacyPopup",
      "toggleServiceModalPopup",
      "toggleLoadingSpinner",
      "toggleLocal",
      "clearReport",
      "updateStepInit",
      "updateSex",
      "updateResult",
      "updateUhrNo",
      "updateStepResponse",
      "selectEvaluation",
      "updateStepResponseError",
    ]),
    ...reactNativeWebViewHelper,
    formDatas,
    inquiry(
      title = "",
      desc = "",
      onClose = () => {},
      yes = "닫기",
      dir = "horizontal",
    ) {
      return new Promise((resolve, reject) => {
        this.toggleInquiry({
          isPopupVisible: true,
          title,
          desc,
          onClose: async () => {
            await onClose();

            this.toggleInquiry({
              isPopupVisible: false,
              title: "",
              desc: "",
              onClose: () => {},
              yes: "닫기",
              dir: "horizontal",
            });

            resolve();
          },
          yes,
          dir,
        });
      });
    },
    locale(local) {
      return this.toggleLocal(local);
    },
    alert(
      title = "",
      desc = "",
      onClose = () => {},
      yes = "닫기",
      dir = "horizontal",
    ) {
      return new Promise((resolve, reject) => {
        this.toggleAlert({
          isPopupVisible: true,
          title,
          desc,
          onClose: async () => {
            await onClose();

            this.toggleAlert({
              isPopupVisible: false,
              title: "",
              desc: "",
              onClose: () => {},
              yes: "닫기",
              dir: "horizontal",
            });

            resolve();
          },
          yes,
          dir,
        });
      });
    },
    confirm(
      title = "",
      message = "",
      desc = "",
      yes = "확인",
      no = "취소",
      onConfirm = () => {},
      onCancel = () => {},
    ) {
      return new Promise((resolve, reject) => {
        if (typeof desc !== "string") {
          reject(new Error("desc 파라메터에는 문자열이 들어가야 합니다"));
        }

        this.toggleConfirm({
          isPopupVisible: true,
          title,
          message,
          desc,
          yes,
          no,
          onConfirm: async () => {
            await onConfirm();

            this.toggleConfirm({
              isPopupVisible: false,
              title: "",
              message: "",
              desc: "",
              yes: "",
              no: "",
              onConfirm: () => {},
              onCancel: () => {},
            });

            resolve({ success: true, type: "confirm" });
          },
          onCancel: async () => {
            await onCancel();

            this.toggleConfirm({
              isPopupVisible: false,
              title: "",
              message: "",
              desc: "",
              yes: "",
              no: "",
              onConfirm: () => {},
              onCancel: () => {},
            });

            resolve({ success: false, type: "cancel" });
          },
        });
      });
    },
    privacy(
      check = false, // 모달 위치에 따라 버튼 및 예외처리하기 ture -> 동의버튼만
      yes = "동의합니다",
      no = "닫기",
      onConfirm = () => {},
      onCancel = () => {},
    ) {
      return new Promise((resolve, reject) => {
        // if (typeof desc !== 'string') {
        //   reject(new Error('desc 파라메터에는 문자열이 들어가야 합니다'));
        // }
        this.togglePrivacyPopup({
          isPopupVisible: true,
          check,
          yes,
          no,
          onConfirm: async () => {
            await onConfirm();

            this.togglePrivacyPopup({
              isPopupVisible: false,
              check: check,
              yes: "",
              no: "",
              onConfirm: () => {},
              onCancel: () => {},
            });

            resolve({ success: true, type: "confirm" });
          },
          onCancel: async () => {
            await onCancel();

            this.togglePrivacyPopup({
              isPopupVisible: false,
              check: check,
              yes: "",
              no: "",
              onConfirm: () => {},
              onCancel: () => {},
            });

            resolve({ success: false, type: "cancel" });
          },
        });
      });
    },
    serviceModal(
      check = false, // 모달 위치에 따라 버튼 및 예외처리하기 ture -> 동의버튼
      yes = "동의합니다",
      no = "닫기",
      onConfirm = () => {},
      onCancel = () => {},
    ) {
      return new Promise((resolve, reject) => {
        // if (typeof desc !== 'string') {
        //   reject(new Error('desc 파라메터에는 문자열이 들어가야 합니다'));
        // }
        this.toggleServiceModalPopup({
          isPopupVisible: true,
          check,
          yes,
          no,
          onConfirm: async () => {
            await onConfirm();

            this.toggleServiceModalPopup({
              isPopupVisible: false,
              check: check,
              yes: "",
              no: "",
              onConfirm: () => {},
              onCancel: () => {},
            });

            resolve({ success: true, type: "confirm" });
          },
          onCancel: async () => {
            await onCancel();

            this.toggleServiceModalPopup({
              isPopupVisible: false,
              check: check,
              yes: "",
              no: "",
              onConfirm: () => {},
              onCancel: () => {},
            });

            resolve({ success: false, type: "cancel" });
          },
        });
      });
    },
    phoneFormatter(num) {
      var formatNum = "";
      if (num.length === 11) {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      } else if (num.length === 8) {
        formatNum = num.replace(/(\d{4})(\d{4})/, "$1-$2");
      } else {
        if (num.indexOf("02") === 0) {
          formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
        } else {
          formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        }
      }
      return formatNum;
    },
    secretPhoneFormatter(num) {
      var formatNum = "";
      formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      formatNum =
        formatNum.substr(0, 4) + "****" + "-" + "**" + formatNum.substr(11, 2);
      return formatNum;
    },
    numberPad(num, width) {
      num = String(num);
      return num.length >= width
        ? num
        : new Array(width - num.length + 1).join("0") + num;
    },
    compressImage(file) {
      if (!file) {
        return null;
      }

      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-new
        new Compressor(file, {
          convertSize: 250000 /* byte */,
          maxHeight: 1024,
          maxWidth: 1024,
          success(result) {
            resolve(result);
          },
          error(err) {
            reject(err);
          },
        });
      });
    },
    isDesktop() {
      // 아이패드 체크
      const isIpad =
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 2) ||
        navigator.platform === "iPad";
      if (isIpad) {
        return false;
      }

      const ua = navigator.userAgent.toLowerCase();
      // eslint-disable-next-line no-useless-escape
      return !(
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          ua,
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          ua.substr(0, 4),
        )
      );
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentPosition(options = {}) {
      return Promise.race([
        new Promise((resolve, reject) => {
          // 비동기 API를 Promise로 처리
          // HTML5 위치 API. (https 에서만 동작함)
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            ...{
              enableHighAccuracy: false,
              maximumAge: 15000, // maximum cached position age
              timeout: 10000,
            },
            ...options, // 옵션 덮어쓰기
          });
        }),
        new Promise((resolve, reject) => {
          setTimeout(resolve, 10000);
        }), // 타임아웃
      ]);
    },
    getRamdomNonUserId() {
      const randomString = (
        length,
        chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      ) => {
        let result = "";
        for (let i = length; i > 0; i -= 1)
          result += chars[Math.floor(Math.random() * chars.length)];
        return result;
      };
      return randomString(6, "0123456789");
    },
    formatPhoneWithHyphen(data) {
      // 전화번호 하이픈(-) 추가형식으로 변경 ex) '01012345678' => '010-1234-5678'
      let formatNum = "";
      if (data.length === 11) {
        formatNum = data.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      } else if (data.length === 8) {
        formatNum = data.replace(/(\d{4})(\d{4})/, "$1-$2");
      } else if (data.indexOf("02") === 0) {
        formatNum = data.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
      } else {
        formatNum = data.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
      return formatNum;
    },
    // 만나이 계산
    calInternationalAge(birth) {
      if (!birth) {
        return "-"; // 정보 없을 때 출력
      }
      const myBirthYMD = this.$moment(birth, "YYYY.MM.DD").format("YYYY-MM-DD");
      const birthday = new Date(myBirthYMD + "T00:00:00.000Z");

      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yyyy = now.getFullYear();
      const nowYMD = yyyy + "-" + mm + "-" + dd + "T00:00:00.000Z";
      const today = new Date(nowYMD);

      let years = today.getFullYear() - birthday.getFullYear();
      birthday.setFullYear(today.getFullYear());

      if (today < birthday) {
        years--;
      }

      return years;
    },
    paginateData(prefix = "") {
      return {
        paramsPrevious: null,
        page:
          Number(this.$route.query[prefix + "offset"]) /
            Number(this.$route.query[prefix + "limit"]) +
            1 || 1,
        pages: null,
        offset: Number(this.$route.query[prefix + "offset"]) || 0,
        limit: Number(this.$route.query[prefix + "limit"]) || 10,
      };
    },
    paginateParams(params, pagination) {
      const paramsNext = {
        ...params,
        ...{
          offset: (pagination.page - 1) * pagination.limit,
          limit: pagination.limit,
        },
      };

      if (!_.isEqual(params, pagination.paramsPrevious)) {
        if (pagination.paramsPrevious !== null) {
          paramsNext.offset = 0;
        }
        pagination.paramsPrevious = _.cloneDeep(
          _.omit(params, ["offset", "limit"]),
        );
      }

      return paramsNext;
    },
    paginate(data, pagination) {
      pagination.page = data.offset / data.limit + 1;
      pagination.pages = Math.ceil(data.count / pagination.limit);

      return data;
    },
    scrollToElement(selector) {
      const el = document.querySelector(selector);
      if (!el) {
        return;
      }

      const top = el.offsetTop;
      const offset = -1;

      document
        .querySelector("html")
        .scroll({ top: top - offset, behavior: "smooth" });
    },
    getDealerBiddingState(item) {
      if (item.state === 1) return 1;
      else if (item.state === 2 && !item.is_applied) return 1;
      else if (item.state === 2 && item.is_applied) return 2;
      else if (item.state === 3 && !item.is_matched) return 7;
      else if (item.state === 3 && item.is_matched) return 3;
      else if (item.state === 4 && !item.is_matched) return 7;
      else if (item.state === 4 && item.is_matched) return 4;
      else if (item.state === 5 && !item.is_matched) return 7;
      else if (item.state === 5 && item.is_matched) return 5;
      else if (item.state === 6 && !item.is_matched) return 7;
      else if (item.state === 6 && item.is_matched) return 6;
      else if (item.state === 7) return 7;
      else if (item.state === 8) return 8;
    },
    getDealerBiddingStateText(item) {
      const a = this.getDealerBiddingState(item);
      switch (a) {
        case 1:
          return "견적요청";
        case 2:
          return "견적제안 중";
        case 3:
          return "매칭완료";
        case 4:
          return "가입진행 중";
        case 5:
          return "가입거절";
        case 6:
          return "가입완료";
        case 7:
          return "견적마감";
        case 8:
          return "기간종료";
      }
    },
    getCarrierName(carrier) {
      // 통신사 코드 -> 통신사명
      return (
        {
          SKT: "SKT",
          KT: "KT",
          LG: "LGU+",
          MVNO: "알뜰폰",
        }[carrier] || ""
      );
    },
  },
};

Vue.mixin(mixin);

export default mixin;
